var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from "@glimmer/tracking";
import InsDocuments from "cnam/components/cnam-services-access-form/ins-documents";
import RateExceeded from "cnam/components/cnam-services-access-form/rate-exceeded";
import AuthorizationState from "cnam/components/dmp-retrieve-access-form/authorization-state";
import SetSecretConnection from "cnam/components/dmp-retrieve-access-form/set-secret-connection";
import { DmpAuthorizationStatus, DocumentStatus, DocumentVisibility, InsStatus } from "cnam/types/types";
import { CnamApiCpsNoPracticeLocations } from "cnam/utils/cnam-api-errors";
import InsWithConfirmationRetrievalContext from "../ins-with-confirmation-retrieval-context";
import { State } from "./cnam-context";
let DmpContext = (_class = class DmpContext extends InsWithConfirmationRetrievalContext {
  constructor(cnamAdapterName, patient, authenticationContext, dmpAdapter, insiAdapter, store, requestManager, onError) {
    super(cnamAdapterName, patient, authenticationContext, insiAdapter, dmpAdapter, store, requestManager, "dmp");
    _initializerDefineProperty(this, "medicDmpAuthorizationStatus", _descriptor, this);
    _initializerDefineProperty(this, "shouldAuthorizeMedicToAccessPatientDmp", _descriptor2, this);
    _initializerDefineProperty(this, "secretConnection", _descriptor3, this);
    _initializerDefineProperty(this, "connectorCreated", _descriptor4, this);
    _initializerDefineProperty(this, "practiceLocationsChecked", _descriptor5, this);
    _initializerDefineProperty(this, "insDocumentIsQualifying", _descriptor6, this);
    _initializerDefineProperty(this, "insIdentityDocument", _descriptor7, this);
    this.patient = patient;
    this.authenticationContext = authenticationContext;
    this.dmpAdapter = dmpAdapter;
    this.insiAdapter = insiAdapter;
    this.store = store;
    this.onError = onError;
    this.insIdentityDocument = patient.insIdentityDocument;
    this.insDocumentIsQualifying = patient.insDocumentIsQualifying;
    this.authenticationContext.forcedIdentifier = this.authenticationContext.medic.forceFinessForCnamRetrieval;
    this.insProcessNeeded = false;
    this.states = [...this.states, new State("check-practice-locations", async () => {
      return Promise.resolve(!this.practiceLocationsChecked);
    }, async () => {
      if (this.authenticationContext?.availableLocations?.length == 0 && !this.authenticationContext?.medic.forceFinessForCnamRetrieval) {
        throw new CnamApiCpsNoPracticeLocations();
      }
      this.practiceLocationsChecked = true;
    }), new State("set-secret-connection", async () => {
      return Promise.resolve((await this.dmpAdapter.shouldSetSecretConnection(this.patient)) && this.secretConnection == undefined);
    }, async () => {
      return;
    }, SetSecretConnection), new State("ins-qualification-needed", async () => {
      return Promise.resolve(this.patient.insStatus !== InsStatus.Qualified && !this.insProcessNeeded);
    }, async () => {
      this.patient.insIdentityDocument = this.insIdentityDocument;
      this.patient.insDocumentIsQualifying = this.insDocumentIsQualifying;
      await this.patient.save();
      this.insProcessNeeded = true;
    }, InsDocuments), new State("rate-exceeded", () => {
      return Promise.resolve((this.dmpAdapter.hourlyRateExceeded || this.dmpAdapter.dailyRateExceeded) && this.patient.insStatus == InsStatus.Qualified);
    }, async () => {
      return;
    }, RateExceeded), new State("create-connector", () => {
      return Promise.resolve(!this.connectorCreated && this.patient.insStatus == InsStatus.Qualified);
    }, async () => {
      await this.dmpAdapter.createConnector();
      this.connectorCreated = true;
      const medicDmpAuthorizationStatus = await this.dmpAdapter.td02Exist(this.patient.ins, this.secretConnection);
      this.shouldAuthorizeMedicToAccessPatientDmp = medicDmpAuthorizationStatus?.authorizationStatus !== DmpAuthorizationStatus.Authorized;
    }), new State("authorize-medic", () => {
      return Promise.resolve(this.shouldAuthorizeMedicToAccessPatientDmp && this.patient.insStatus == InsStatus.Qualified);
    }, async () => {
      await this.dmpAdapter.td03AddAuthorization(this.patient.ins, this.secretConnection);
      const medicDmpAuthorizationStatus = await this.dmpAdapter.td02Exist(this.patient.ins, this.secretConnection);
      this.shouldAuthorizeMedicToAccessPatientDmp = medicDmpAuthorizationStatus?.authorizationStatus !== DmpAuthorizationStatus.Authorized;
    }, AuthorizationState)];
  }
  reset() {
    super.reset();
    this.medicDmpAuthorizationStatus = undefined;
    this.shouldAuthorizeMedicToAccessPatientDmp = false;
    this.insIdentityDocument = this.patient.insIdentityDocument;
    this.insDocumentIsQualifying = this.patient.insDocumentIsQualifying;
    this.secretConnection = undefined;
    this.currentState = undefined;
    this.connectorCreated = false;
    this.practiceLocationsChecked = false;
  }
  async findDocuments(patient, store, filterCriteria = {}) {
    const criteria = Object.assign({
      visibilities: [DocumentVisibility.NORMAL],
      statuses: [DocumentStatus.APPROVED]
    }, filterCriteria);
    const documents = await this.dmpAdapter.td31Find(patient.ins, criteria, this.secretConnection);
    await store.createRecord("dmp-retrieval-started-journal-event", {
      cpsId: this.authenticationContext.cpsInformations.medicInternalId,
      occurredAt: new Date(),
      patient,
      cnamProcessStartedJournalEvent: this.cnamProcessStartedJournalEvent
    }).save();
    return documents;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "medicDmpAuthorizationStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "shouldAuthorizeMedicToAccessPatientDmp", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "secretConnection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "connectorCreated", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "practiceLocationsChecked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "insDocumentIsQualifying", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "insIdentityDocument", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DmpContext as default };